var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCestar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.53866H11.1232L9.00627 0L6.87681 6.53866L0 6.52612L5.5616 10.572L3.43213 17.1107L8.99373 13.0647L14.5553 17.1107L12.4384 10.572L18 6.53866Z",
    fill: "#00D988"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.912 12.0523L12.436 10.5742L9.00391 13.0669L12.912 12.0523Z",
    fill: "#0A6845"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCestar);
export default __webpack_public_path__ + "static/media/cestar.7bccdeb514e83cbfe5bc1014416cccf8.svg";
export { ForwardRef as ReactComponent };